export const translations = {
	'Create log entry': { no: 'Opprett loggmelding' },
};
